var map = {
	"./logo-barefoot.svg": "C1bF",
	"./logo-biscuit.svg": "5rsv",
	"./logo-collision.svg": "zoQ1",
	"./logo-granton.svg": "5bzO",
	"./logo-magritte.svg": "dZVC",
	"./logo-mercer.svg": "Bkc6",
	"./logo-olasio.svg": "xW9d",
	"./logo-rbi-emails.svg": "woY9",
	"./logo-rbi-report.svg": "rRYK",
	"./logo-rbi-scheduler.svg": "S0Vn",
	"./logo-rbi-website.svg": "aEtE",
	"./logo-t2.svg": "nJIZ",
	"./logo-teamable.svg": "3JwC",
	"./logo-transcope.svg": "JTu9",
	"./logo-wikiprice.svg": "p1oC",
	"./logo-zigzag.svg": "Uld7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TlR/";


//////////////////
// WEBPACK FOOTER
// ./static/image/logos ^\.\/logo\-.*\.svg$
// module id = TlR/
// module chunks = 0